import { render, staticRenderFns } from "./simple_modal_header.vue?vue&type=template&id=7e69b240&"
import script from "./simple_modal_header.vue?vue&type=script&lang=js&"
export * from "./simple_modal_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports